import { useState } from "react";
import useApi from "../hooks/useApi";
import { PatientId } from "../schema/schema";
import Chat from "./Chat";

interface PatientTaskChatProps {
  patientId: PatientId;
}

export default function PatientTaskChat({ patientId }: PatientTaskChatProps) {
  const [response, setResponse] = useState("");
  const [loading, setLoading] = useState(false);
  const { api } = useApi();

  const handleSendMessage = async (question: string) => {
    setLoading(true);
    setResponse("");

    try {
      const { summary } = await api.post("./patients/:patientId/task_history_summary_chat", {
        path: { patientId },
        body: { questions: [question] },
      });

      setResponse(summary);
    } catch (error) {
      console.error("Error fetching task history summary:", error);
      setResponse("Sorry, there was an error processing your request.");
    } finally {
      setLoading(false);
    }
  };

  return <Chat loading={loading} response={response} onSendMessage={handleSendMessage} />;
}
